import Moment from "moment";
const calculateMaxDate = () => {
  const dateObj = new Date();
  dateObj.setDate(dateObj.getDate() - 1);
  return Moment(dateObj);
};

export const formatDate = (dateInput, formatStr = "MM/DD/YYYY") => {
  if (!!dateInput) {
    const date = Moment(dateInput)
      .utc()
      .format(formatStr);
    if (date !== "Invalid date") {
      return date;
    }
  }
  return "";
};

// Put this in place to fix the issue where the roster date is not formatted correctly
export const formatRosterDate = ts => {
  if (ts === null || ts === undefined || ts === "") return "";

  let m;

  if (typeof ts === "number") {
    const ms = ts > 1e12 ? ts : ts * 1000;
    m = Moment.utc(ms);
  } else if (typeof ts === "string") {
    const s = ts.trim();
    if (/^\d+$/.test(s)) {
      const num = Number(s);
      m = Moment.utc(num > 1e12 ? num : num * 1000);
    } else {
      // Trim fractional seconds to milliseconds for strict ISO parsing
      const normalized = s.replace(/(\.\d{3})\d+/, "$1");
      m = Moment.utc(normalized, Moment.ISO_8601, true);
      if (!m.isValid()) {
        m = Moment.utc(normalized);
      }
    }
  } else {
    return "";
  }

  if (!m.isValid()) return "";
  return m.local().format("MM/DD/YYYY - HH:mm");
};

export const formatLocalDateTimeStr = localDateTimeStr => {
  if (!localDateTimeStr) {
    return "";
  }
  const cleaned = localDateTimeStr.replace(/\.\d{6}.*$/, "");
  const parsed = Moment(cleaned, "YYYY-MM-DD HH:mm:ss");
  const formatted = parsed.format("M/D/YYYY h:mm a");
  return formatted;
};

export const maxFormDate = calculateMaxDate();
export const minFormDate = Moment(new Date("1/1/1910").valueOf());
export const isSameOrBefore = (dateStr1, dateStr2) => Moment(dateStr1).isSameOrBefore(dateStr2);
